// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PaginationCarouselCircleArrowUp: React.FC<{
    size?: number;
    color1?: string;
    color2?: string;
    className?: string;
}> = ({ size = 18, color1 = "#fff", color2 = "#577538", className }) => (
    <svg className={className} focusable="false" viewBox="0 0 18 18" width={size} height={size}>
        <g fill="none" fillRule="evenodd" transform="rotate(90 9 9)">
            <circle cx="9" cy="9" r="9" fill="currentColor" fillOpacity=".9" />
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0m0 .5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17"
            />
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M7.097 9.289a.48.48 0 0 1 0-.578l3.335-4.092a.293.293 0 0 1 .471 0 .48.48 0 0 1 0 .578L7.803 9l3.1 3.803a.48.48 0 0 1 0 .578.293.293 0 0 1-.471 0z"
            />
        </g>
    </svg>
);

export default React.memo(PaginationCarouselCircleArrowUp);
